/**
 * ——封装月视图横向 链表结构数据 的工具类
 * ——应用：视图界面 月视图 计算展示信息时调用；
 */


export default {

    /**
     * 获取链表数据总线，并以7天为一个单位切割子线
     * @param dayItems [{*}]
     * @param chainCount [{*}]
     * @param viewType
     * @returns {*}
     */
    setChainItems: function(dayItems, chainCount, viewType){
        if(viewType === "month"){
            const monthChainArray = this.getChainArray(dayItems);
            const chainItems = this.getChainItems(dayItems, chainCount);
            this.splitChainArray(monthChainArray, chainItems);
            return monthChainArray
        }else if(viewType === "week"){
            const weekChainItem = [];
            const chainItems = this.getChainItems(dayItems, chainCount);
            // 周 开始天下标，周 结束天下标；
            this.setChainArray(chainItems, weekChainItem, 0, 6);

            return weekChainItem;
        }else{
            const dayChainArray = [];
            const chainItems = this.getChainItems(dayItems, chainCount);
            chainItems.forEach((chainItem)=>{
                if(chainItem.chainMatter.length > 0){
                    dayChainArray.push(chainItem.chainMatter)
                }
            })
            return dayChainArray
        }
    },
    getChainArray: function(dayItems){
        const monthChainArray = [];
        for(let i=0, l=dayItems.length / 7; i< l; i++){
            monthChainArray.push({
                rowId: i,
                chainArray: [],
                dayItems: dayItems.slice(i*7, (i+1) * 7)
            })
        }
        return monthChainArray
    },
    getChainItems: function(dayItems, chainCount){
        const chainItems = [];
        let dayItemsCopy = JSON.parse(JSON.stringify(dayItems));
        for (let i=0; i< chainCount; i++){
            // 链式数据数组

            let chainItem = {
                chainMatter: [],
                chainIndex: i,
            }

            if(i < chainCount-1){
                chainItem = this.createAllChain(chainItem, dayItemsCopy);
                chainItems.push(chainItem);
            }else{
                chainItem = this.createCountChain(chainItem, dayItems, chainItems);
                chainItems.push(chainItem)
            }
        }
        return chainItems;
    },
    splitChainArray: function(monthChainArray, chainItems){
        monthChainArray.forEach((item, index)=>{
            // 周 开始天下标，周 结束天下标；
            const firstIndex = index * 7;
            const lastIndex = firstIndex + 6;
            this.setChainArray(chainItems, item.chainArray, firstIndex, lastIndex);
        })
    },
    setChainArray: function(chainItems, weekChainArray, firstIndex, lastIndex){
        chainItems.forEach((chainItem)=>{
            const chainArray = [];
            chainItem.chainMatter.forEach((matterItem)=>{
                if((matterItem.startDayIndex >= firstIndex && matterItem.startDayIndex <= lastIndex)
                    || (firstIndex > matterItem.startDayIndex && matterItem.endDayIndex >= firstIndex)
                ){
                    // 当周开始 或 当周之前开始未结束
                    const tempItem = JSON.parse(JSON.stringify(matterItem));
                    if(firstIndex > tempItem.startDayIndex){
                        // 截取开始
                        tempItem.startDayIndex = firstIndex;
                    }
                    if(tempItem.endDayIndex > lastIndex){
                        // 截取结束
                        tempItem.endDayIndex = lastIndex;
                    }

                    // 获取距左间隔
                    let leftNum
                    if(chainArray.length > 0){
                        const prevMatterEndDay = chainArray[chainArray.length - 1].endDayIndex;
                        if(Math.trunc(prevMatterEndDay / 7) !== Math.trunc(tempItem.startDayIndex / 7)){
                            leftNum = tempItem.startDayIndex % 7
                        }else{
                            leftNum = tempItem.startDayIndex - prevMatterEndDay - 1
                        }
                    }else{
                        leftNum = tempItem.startDayIndex % 7
                    }
                    tempItem.leftNum = leftNum;
                    // 差别
                    // if (weekChainIndex > 0 && weekChainIndex < array.length - 1 && !tempItem.sameMonth){
                    //     tempItem.sameMonth = true
                    // }
                    chainArray.push(tempItem);
                }
            })
            if(chainArray.length !== 0){
                weekChainArray.push(chainArray);
            }
        })
    },
    /**
     * 生成总线数据
     * @param chainItem
     * @param dayItems
     * @returns {*}
     */
    createAllChain: function(chainItem, dayItems){
        let isCrossAdd = false;
        // 链式数据
        dayItems.forEach((dayItem, dayIndex)=>{
            // 取当前天 第一个清单
            if(isCrossAdd){
                // 跨天延申
                let matterItem = chainItem.chainMatter[chainItem.chainMatter.length-1];
                matterItem.endDayIndex = dayIndex;
                if(dayItem.date === matterItem.crossEndDate){
                    isCrossAdd = false;
                }
                return
            }
            // 插入清单

            if(dayItem.matterArray.length > 0){
                isCrossAdd = this.insertMatter(dayIndex, dayItem, chainItem, isCrossAdd);
            }
        });
        return chainItem
    },
    /**
     *  插入清单
     */
    insertMatter: function(dayIndex, dayItem, chainItem, isCrossAdd){
        const matterItem = this.getMatterItem(dayItem.matterArray, dayIndex, dayItem.date);
        if(!matterItem){
            return isCrossAdd
        }
        if(matterItem.info.crossDays > 0){
            // 跨天
            isCrossAdd = dayItem.date !== matterItem.info.crossEndDate;
        }
        chainItem.chainMatter.push({
            startDayIndex: dayIndex,
            endDayIndex: dayIndex,
            crossEndDate: matterItem.info.crossEndDate,
            leftNum: 0,
            text: matterItem.info.title,
            color: matterItem.info.color,
            sameMonth: dayItem.sameMonth,
            state: matterItem.timeInfo.state,
            matterItem: matterItem
        })
        return isCrossAdd
    },

    /**
     * 根据是否展示已打卡清单的设置获取一条清单
     * @param matterArray
     * @param dayIndex
     * @param date
     * @returns {*}
     */
    getMatterItem: function(matterArray, dayIndex, date){
        if(matterArray.length === 0){
            return
        }
        const matterItem = matterArray.splice(0,1)[0];
        if(dayIndex >0 && matterItem.info.crossDays > 0 && matterItem.info.startDate !== date){
            return this.getMatterItem(matterArray, dayIndex, date)
        }else{
            return matterItem
        }
    },


    /**
     * 生成剩余量子线
     * @param chainItem
     * @param dayItems
     * @param chainItems
     * @returns {*}
     */
    createCountChain: function(chainItem, dayItems, chainItems){
        dayItems.forEach((dayItem, dayIndex)=>{
            // 初始化计数 仅当天的事件 : 清单
            let matterCount = dayItem.matterArray.length;
            // 展示的事件
            const showCount = this.countShowChain(dayIndex, chainItems);
            matterCount -= showCount;
            if(matterCount > 0){
                let text;
                if(matterCount > 10){
                    text = "+10";
                }else{
                    text = "+" + matterCount;
                }
                chainItem.chainMatter.push({
                    startDayIndex: dayIndex,
                    endDayIndex: dayIndex,
                    leftNum: 0,
                    text: text,
                    color: "#EEEEEE",
                    sameMonth: dayItem.sameMonth,
                    state: 0,
                })
            }
        });
        return chainItem
    },
    /**
     * 计算展示事项的数量
     * @param dayIndex
     * @param chainItems
     * @returns {number}
     */
    countShowChain: function (dayIndex, chainItems){
        let showCount = 0;
        chainItems.forEach((chainItem)=>{
            chainItem.chainMatter.forEach((chainMatterItem)=>{
                if(dayIndex >= chainMatterItem.startDayIndex && dayIndex <= chainMatterItem.endDayIndex){
                    showCount ++;
                }
            })
        })
        return showCount
    },
}